module.exports = __webpack_public_path__ + "img/shop_default.718571c4.png";